<template>
  <div class="w-100">
    <span id="ticket-home"></span>
		<Mobile 
      :key="refresh_child.mobile"
			v-if="is_mobile_view"
      ref="mobile_view"
      :data_parent="data_to_child"
      :load_product="loadProductActivities"
      :load_product_transport="loadProductTransport"
      @productSpecialSelected="productSpecialSelected"
      @selectTransportFilter="selectTransportFilter"
      @updateTransportDate="updateTransportDate"
			>
		</Mobile>
		<Desktop 
      :key="refresh_child.desktop"
      v-else
      ref="desktop_view"
      :data_parent="data_to_child"
      :load_product="loadProductActivities"
      :load_product_transport="loadProductTransport"
      @productSpecialSelected="productSpecialSelected"
      @selectTransportFilter="selectTransportFilter"
      @updateTransportDate="updateTransportDate"
			>
		</Desktop>
	</div>
</template>

<script>
  import Desktop from './TicketHomePageDesktop'; 
	import Mobile from './TicketHomePageMobile';
	// import Mobile from './MerchantDetail';
  import {mapGetters,mapActions,mapMutations} from 'vuex';
  import {get,post} from '@/services/index.js'
  import moment from 'moment'

  export default {
    components:{
      Desktop,
      Mobile
    },
    data() {
      return {
        is_load: true,
        merchant_area: '',
        product: {
          list: [],
          is_load: true,
          error: ''
        },
        review:{},
        product_special: {},
        transport_route: {
          from: {
            list: [],
            selected: {}
          },
          to: {
            list: [],
            selected: {}
          }
        },
        transport_date:{
          departure:{
            startDate: moment().toDate()
          },
          is_return: false,
          return:{
            startDate: moment().toDate()
          }
        },
        refresh_child:{
          mobile: 0,
          desktop: 0
        },
        opening_time: {
          today: {},
          all_day: []
        }
      }
    },
    computed:{
      ...mapGetters(['getMerchant','getMerchantLoad','getTicketCart','getTicketFilterTransport','getTicketTransportCart']),
      is_mobile_view(){
				return window.innerWidth > 768 ? false : true
			},
      data_to_child(){
        return {
          merchant_area: this.merchant_area,
          is_load: this.is_load,
          product: this.product,
          product_special: this.product_special,
          review: this.review,
          transport_route: this.transport_route,
          transport_date: this.transport_date,
          opening_time: this.opening_time
        }
      }
    },
    watch:{
      getMerchantLoad(){
				if(!this.getMerchantLoad){
          this.openingDays()
          if(this.getMerchant.merchant_category_name == 'TRANSPORT'){
            this.loadFilterTransport()
          }
					this.loadFirstData()
				}
			}
    },
    mounted(){
      
    },
    methods:{
      ...mapActions(['ticketResetItemCart','ticketSetBookingDateCart']),
      ...mapMutations(['ticketUpdateDataCart','ticketSetPromoCode','ticketSetProductSpecial','setTicketAvb','setTicketFilter','setTicketHeaderMenu']),
      loadFirstData(){
        this.is_load = true
        let func_exe = [this.loadMerchantArea(),this.loadReview()]
        
        if(this.getMerchant.merchant_category_name == 'ACTIVITIES' && this.getMerchant.use_product_special) func_exe.push(this.loadProductSpecial())
        else this.ticketSetProductSpecial({})
      
        if(this.getMerchant.merchant_category_name == 'TRANSPORT') {
          func_exe.push(this.loadTransportRoute())
          func_exe.push(this.loadProductTransport())
        }else{
          func_exe.push(this.loadProductActivities(true,this.getTicketCart.promo_code))
        }

        Promise.all(func_exe).catch(err=>{
          console.log("loadFirstData :", err)
        }).finally(()=>{
          setTimeout(() => {
            let hash = this.$route.hash
            if(hash != ''){
              this.$smoothScroll('home-review')
              this.$router.replace(this.$route.path);
            }else{
              this.$smoothScroll('ticket-home')
            }
          }, 500);
          this.is_load = false
        })
      },
      loadMerchantArea(){
        return new Promise((success,fail)=>{
          get("CORE","user-location",{
            lat: this.getMerchant.lat,
            long: this.getMerchant.lng
          }).then(response=>{
            let res = response.data
            if(res.success){
              let location_type = res.data.address_components
              for(let i = 0; i < location_type.length;i++){
                if (location_type[i].types[0] == 'administrative_area_level_3') {
                  this.merchant_area = location_type[i].long_name;
                  break;
                }
              }
              success()
            }else{
              success()
            }
          })
        })
      },
      loadProductSpecial(){
        return new Promise((success,fail)=>{
          get("CORE","product-special-option",{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.product_special = res.data
              if(this.getTicketCart.product_special && this.getTicketCart.product_special.id){
                let is_ps_in_vuex = this.product_special.findIndex(x=>x.id == this.getTicketCart.product_special.id)
                if(is_ps_in_vuex == -1){
                  this.ticketSetProductSpecial({})
                }else{
                  if(this.is_mobile_view) this.$refs.mobile_view.updateProductSpecialSelected(this.getTicketCart.product_special)
                  else this.$refs.desktop_view.updateProductSpecialSelected(this.getTicketCart.product_special)
                }
              }
              success()
            }else{
              fail(res.message)
            }
          })
        })
      },
      loadTransportRoute(){
        return new Promise((success,fail)=>{
          get("CORE",`merchant-route/${this.getMerchant.id}`).then(response=>{
            let res = response.data
            if(res.success){
              this.transport_route.from.list = res.data
              this.validateTransportRoute(res.data).finally(()=>success())
            }else{
              fail(res.message)
            }
          })
        })
      },
      loadProductActivities(first_load=false,promo_code=''){
        return new Promise((success,fail)=>{
          if(first_load){
            this.product = {
              list: [],
              is_load: true,
              error: ''
            }
          }
          let today = moment().format('YYYY-MM-DD')
          let visit_date = moment(this.getTicketCart.visit_date).format("YYYY-MM-DD") 
          if(moment(visit_date).isBefore(today,'day')){
            this.ticketResetItemCart()
            this.ticketSetBookingDateCart(moment().toDate())
          }
          get("CORE","ticket",{
            merchant_id: this.getMerchant.id,
            date_time: moment(this.getTicketCart.visit_date).format("YYYY-MM-DD"),
            promo_code: promo_code
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.saveDataProductList(res.data)
              success(res)
            }else{
              if(first_load && res.message == 'promo_code not found'){
                this.ticketSetPromoCode("")
                this.ticketResetItemCart()
                this.loadProduct().then(res_next=>{
                  if(res_next.success){
                    this.saveDataProductList(res_next.data)
                    success(res_next.data)
                  }else{
                    this.product.error = res.message
                    fail(res_next.message)
                  }
                })
              }else{
                this.product.error = res.message
                fail(res.message)
              }
            }
            this.product.is_load = false
          })
        })
      },
      loadProductTransport(is_return=false){
        return new Promise((success,fail)=>{
          this.product = {
            list: [],
            return_list: [],
            is_load: true,
            error: ''
          }

          let params = {
            merchant: this.getMerchant.id,
            from: this.getTicketFilterTransport.from.id,
            to: this.getTicketFilterTransport.to.id,
            date: moment(this.getTicketFilterTransport.departure).format("YYYY-MM-DD"),
            min_availability: 0
          }

          if(is_return){
            let variant = this.getTicketTransportCart.departure.variant[0]
            let all_variant = this.$deepCopy(this.getTicketTransportCart.departure.variant)
            params.from = variant.data.route_to.reference_id
            params.to = variant.data.route_from.id
            params.date = moment(this.getTicketFilterTransport.return).format("YYYY-MM-DD")
            params.min_availability = all_variant.reduce((total, current) => total + current.qty, 0)
            params.variants = all_variant.map(x=>x.data.variant_id)
          }
          
          post("CORE","ticket-transport",params).then(response=>{
            let res = response.data
            if(res.success){
              if(is_return){
                this.product.return_list = res.data
              }else{
                this.product.list = res.data
              }
              success()
            }else{
              fail(res.message)
            }
            this.product.is_load = false
          })
        })
      },
      loadReview(){
        return new Promise((success,fail)=>{
          this.review = {}
          let params = {
            merchant: this.getMerchant.id,
            keyword: '',
            page: 1,
            page_size: 5
          }
          get("CORE","merchant-ticket-feedback",params).then(response=>{
            let res = response.data
            if(res.success){
              this.review = res.data
              if(res.data.all_feedback.data.length > 0){
                this.setTicketHeaderMenu([
                  {
                    key: 'review',
                    value: true
                  }
                ])
              }
              success()
            }else{
              fail(res.message)
            }
          })
        })
      },
      
      saveDataProductList(data){
        this.product.list = data
        this.product.list = this.product.list.map(x=>{
          x.variants = x.variants.map(y=>{
            y.id_cart = y.id 
            y.best_price = y.product_special[0]
            return y
          })
          x.total_availability = x.variants.reduce((accumulator,currentValue)=>accumulator + currentValue.availability, 0)
          return x
        })
        if(this.getTicketCart.ticket_details.length > 0) this.ticketUpdateDataCart(this.product.list)
        if(this.getTicketCart.product_special && this.getTicketCart.product_special.id) this.productSpecialSelected(this.getTicketCart.product_special)
        this.saveAvbl(this.product.list)
      },
      saveAvbl(data){
        let ticket_avb = []
        data.forEach(product=>{
          product.variants.forEach(variant=>{
            let new_data = {
              id: variant.id,
              availability: variant.availability,
              original_availability: variant.availability
            }
            if(!variant.use_master_availability){
              let is_exist = ticket_avb.findIndex(x=>x.id == variant.id)
              if(is_exist == -1){
                ticket_avb.push(new_data)
              }
            }else{
              variant.master_availability_reference.forEach(master_avb=>{
                let is_exist = ticket_avb.findIndex(x=>x.id == master_avb.reference_id)
                if(is_exist == -1){
                  new_data.id = variant.master_availability_reference_id
                  ticket_avb.push(new_data)
                }
              })
            }
          })
        })
        this.setTicketAvb(ticket_avb)
      },
      productSpecialSelected(data){
        this.ticketSetProductSpecial(data)
        this.product.list = this.product.list.map(product=>{
          product.variants = product.variants.map(variant=>{
            if(Object.keys(data).length > 0){
              if(variant.product_special.length > 1){
                let new_price = variant.product_special.findIndex(ps=>ps.id == data.id)
                if(new_price != -1){
                  variant.id_cart = variant.product_special[new_price].product_ticket_id
                  variant.best_price = variant.product_special[new_price]
                }else {
                  variant.id_cart = variant.id
                  variant.best_price = variant.product_special[0]
                }
              }
            }else{
              variant.id_cart = variant.id
              variant.best_price = variant.product_special[0]
            }
            return variant
          })
          return product
        })
        if(this.getTicketCart.ticket_details.length > 0) this.ticketUpdateDataCart(this.product.list)
      },
      validateTransportRoute(data){
        return new Promise(done=>{
          let vuex_data = this.getTicketFilterTransport
          if(!this.$isObjectEmpty(vuex_data.from)){
            let is_from_in_list = -1
            data.forEach((x,i)=>{
              let child_exist = x.child.findIndex(y=>y.id == vuex_data.from.id)
              if(child_exist != -1) {
                is_from_in_list = i
              }
            })
            if(is_from_in_list == -1){
              this.selectTransportFilter({
                type: 'reset',
                data: 'from'
              })
              this.selectTransportFilter({
                type: 'reset',
                data: 'to'
              })
            }else{
              this.transport_route.from.selected = this.$deepCopy(vuex_data.from)
              this.transport_route.to.list = data.filter(x=>x.id != this.transport_route.from.list[is_from_in_list].id)
              if(!this.$isObjectEmpty(vuex_data.from)){
                let is_to_in_list = data.findIndex(x=>x.id == vuex_data.to.id)
                if(is_to_in_list == -1){
                  this.selectTransportFilter({
                    type: 'reset',
                    data: 'to'
                  })
                }else{
                  this.transport_route.to.selected = this.$deepCopy(vuex_data.to)
                }
              }
            }
          }
          done()
        })
      },
      selectTransportFilter(params){
        let vuex_params = {
          type: 'transport',
          data: []
        }
        if(params.type == 'reset'){
          if(params.data == 'from'){
            this.transport_route.from.selected = {}
            vuex_params.data.push({key: 'from', value: {}})
          }else{
            this.transport_route.to.selected = {}
            vuex_params.data.push({key: 'to', value: {}})
          }
        }else{
          if(params.type == 'from'){
            let from_list = this.$deepCopy(this.transport_route.from.list)
            this.transport_route.from.selected = from_list[params.data.parent].child[params.data.child]
            vuex_params.data.push({key: 'from', value: this.transport_route.from.selected})
            
            if(this.transport_route.to.selected.id && from_list[params.data.parent].id == this.transport_route.to.selected.id) {
              this.transport_route.to.selected = {} 
              vuex_params.data.push({key: 'to', value: this.transport_route.to.selected})
            }
  
            this.transport_route.to.list = from_list.filter(x=>x.id != from_list[params.data.parent].id)
            if(!this.transport_route.to.selected.id){
              let viewtype_function = this.is_mobile_view ? this.$refs.mobile_view : this.$refs.desktop_view
              viewtype_function.toggleDDTo()
            }
          }else{
            this.transport_route.to.selected = this.transport_route.to.list[params.data.parent]
            vuex_params.data.push({key: 'to', value: this.transport_route.to.selected})
          }
        }
        this.setTicketFilter(vuex_params)
      },
      loadFilterTransport(){
        let data = this.$deepCopy(this.getTicketFilterTransport)
        this.transport_date = {
          departure:{
            startDate: data.departure
          },
          is_return: data.is_return,
          return:{
            startDate: data.return
          }
        }
        this.refresh_child.desktop++
        this.refresh_child.mobile++
      },
      updateTransportDate(params){
        if(params.type == 'is_return') this.transport_date[params.type] = params.data
        else this.transport_date[params.type].startDate = params.data
        
        let is_return_before_departure = moment(this.transport_date.return.startDate).isBefore(this.transport_date.departure.startDate)
        if(params.type == 'departure' && is_return_before_departure){
          this.transport_date.return.startDate = this.transport_date.departure.startDate
        }

        let vuex_params = {
          type: 'transport',
          data: [
            {key: 'departure', value: this.transport_date.departure.startDate},
            {key: 'is_return', value: this.transport_date.is_return},
            {key: 'return', value: this.transport_date.return.startDate}
          ]
        }
        this.setTicketFilter(vuex_params)
      },
      openingDays() {
        let today = moment().format("d")
        let day_in_week = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday']
        let opening_days = []
        day_in_week.forEach((day,day_i)=>{
          let sale = `sale_${day}`
          let hour_start = `time_start_${day}`
          let hour_end = `time_end_${day}`
          let open_day = {
            day: moment(day_i,'d').format('dddd'),
            is_open: this.getMerchant[sale],
            operational_hour: !this.getMerchant.use_daily_operational_hour ? {} : {
              start: this.formatHour(this.getMerchant[hour_start]),
              end: this.formatHour(this.getMerchant[hour_end])
            }
          }

          opening_days.push(open_day)
        })
        
        this.opening_time = {
          today: opening_days[today],
          all_day: opening_days
        }
      },
      formatHour(time){
        return moment(time, 'HH:mm:ss').format('hh:mm A')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/ticket/TicketHomePage.vue